import React, { useEffect, useState } from "react";
import { WorkerStatusCard } from '../assets/style'
import { Box, Typography, Button, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Card, Select, MenuItem } from '@mui/material';
import styled from "@mui/system/styled";
import SearchDropDownList from "./SearchDropDownList";
import { useTranslation } from "react-i18next";

function AlertByCategoryCard(props: { data?: any }) {
    const { data } = props;
    const [type, setType] = useState<string | undefined>("Critical")
    const [dataArray, setDataArray] = useState(data ? data : []);
    const count = dataArray?.length;
    const {t, i18n} = useTranslation();

    useEffect(() => {
        // console.log(data);
        if (!(data == null || data == undefined)) {
            setDataArray(data);
        }
    }, [data])

    const generateRows = (count: number) => {
        const rows = [];
        const defaultColor = ["#27ebf2", "#2775f2", "#f2f227", "#27f2b5", "#2a27f2", "#8927f2", "#27f253", "#f28927", "#f227b2", "#f22738"];
        for (let i = 0; i < count && i < count; i++) {
            const [date, timeString] = (dataArray[i]?.alertTime?.split(' ')) || [];
            const [time, _] = (timeString?.split('.')) || [];
            rows.push({ id: dataArray[i].alertId, alert: dataArray[i].alertType, projectNo: dataArray[i].projectNumber, loaction: dataArray[i].location, date: date, time: time, type: dataArray[i].alertLevel });
        }
        return rows;
    };
    const WorkerStatusCard = styled(Box)`
    margin: 10px;
    hight: 100%;
    width: 100%;
    min-height: 400px;
    min-width: 500px;
    overflow: hidden;
    border-radius: 12px;
    @media (max-width: 800px){
      //width: 100%;
      max-width: 400px;
      min-width: 200px;
      //align-items: center;
      //justify-content: center;
    }
  `
    var items = ["Critical", "Medium", "Minor"]

    return (
        <>
            <WorkerStatusCard sx={{ minHeight: '300px', maxHeight: '500px', height: '100%', "@media (max-width: 800px)": { maxWidth: '800px', maxHeight: '500px' } }}>
                <Box sx={{ display: "flex", flexDirection: 'column', alignContent: "center", height: "100%", marginLeft: '20px', marginRight: '20px', "@media (max-width: 800px)": { justifyContent: "center", justifyItems: "center", alignItems: "center", marginLeft: "0px", flexDirection: "column" } }}>
                    {/* <Box sx={{ float: "left", marginTop: "10px", marginLeft: "10px", width: "100%", height: "10%", display: "row" }}>
                        <Typography variant="h6" style={{ color: "#193057" }}>Lastest Alert</Typography>
                        {/* <SearchDropDownList title={"Type"} value={type} handleValueChange={(e: any) => { }} items={["", "", ""]} /> 
                    <Select
                        value={type}
                        onChange={(event) => { }}
                        style={{ marginBottom: "20px", backgroundColor: "white", height: "32px" }}
                    >
                        {items?.map((item, index) => (
                            <MenuItem key={index} value={item}>
                                {item}
                            </MenuItem>
                        ))}
                    </Select>
                </Box> */}
                    <Box sx={{ float: "left", marginLeft: "10px", width: "100%", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                        <Typography variant="h6" style={{ color: "#193057" }}>{t("Alert by category")}</Typography>
                        <Select
                            value={type}
                            onChange={(event) => { setType(event.target.value) }}
                            style={{ marginRight: "10px", backgroundColor: "white", height: "32px" }}
                        >
                            {items?.map((item, index) => (
                                <MenuItem key={index} value={item}>
                                    {t(item)}
                                </MenuItem>
                            ))}
                        </Select>
                    </Box>
                    <Box>
                        <TableContainer sx={{ "@media (max-width: 800px)": { maxWidth: '360px', maxHeight: '450px', height: '90%' }, maxHeight: '360px', overflowY: 'auto' }}>
                            <Table sx={{ maxHeight: "80px" }} size='small' aria-label="simple table">
                                <TableHead sx={{ position: "sticky", top: "0", zIndex: "1", backgroundColor: '#ffffff' }}>
                                    <TableRow>
                                        <TableCell component="th" scope="row" style={{ color: '#1481c9', fontSize: 16 }}>{t("Alert")}</TableCell>
                                        <TableCell align="left" style={{ color: '#1481c9', fontSize: 16 }}>{t("Project No.")}</TableCell>
                                        <TableCell align="left" style={{ color: '#1481c9', fontSize: 16 }}>{t("Location")}</TableCell>
                                        <TableCell align="left" style={{ color: '#1481c9', fontSize: 16 }}>{t("Date")}</TableCell>
                                        <TableCell align="left" style={{ color: '#1481c9', fontSize: 16 }}>{t("Time")}</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody sx={{ '& .MuiTableCell-root': { borderBottom: "none" } }}>
                                    {generateRows(count).map((row) => (
                                        row?.type == type &&
                                        <TableRow key={row.id} sx={{ ',&:last-child td, &:last-child th': { borderLeft: 0, borderRight: 0, borderBottom: 4, borderColor: "#ffffff", backgroundColor: "#d7ebfa" } }}>
                                            <TableCell component="th" scope="row">{row.alert}</TableCell>
                                            <TableCell align="left">{row.projectNo}</TableCell>
                                            <TableCell align="left">{row.loaction}</TableCell>
                                            <TableCell align="left">{row.date}</TableCell>
                                            <TableCell align="left">{row.time}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                </Box>
            </WorkerStatusCard >
        </>
    )
}

export default AlertByCategoryCard;